module.exports = __webpack_public_path__ + "static/media/ippf-logo.556b0154.png";